// Thin line icons, drawn to sit next to wide-tracked uppercase type.
const paths = {
  bag: <path d="M5 8h14l-1 12H6L5 8Zm4 0V6a3 3 0 0 1 6 0v2" />,
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4.5 4.5" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6 6 18" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  down: <path d="m6 9 6 6 6-6" />,
  left: <path d="m15 6-6 6 6 6" />,
  right: <path d="m9 6 6 6-6 6" />,
  arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
  filter: <path d="M4 7h10m4 0h2M4 17h4m4 0h8M14 5v4M8 15v4" />,
  zoom: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4.5 4.5M11 8.5v5M8.5 11h5" />
    </>
  ),
  truck: <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7M7 19a1.6 1.6 0 1 0 0-.1M17 19a1.6 1.6 0 1 0 0-.1" />,
  box: <path d="M12 3.5 19.5 7.5v9L12 20.5 4.5 16.5v-9ZM4.5 7.5 12 11.5l7.5-4M12 11.5v9" />,
  returns: <path d="M9 7H5V3M5.5 7A8 8 0 1 1 4 12" />,
  lock: (
    <>
      <rect x="5.5" y="10.5" width="13" height="9.5" />
      <path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  copy: (
    <>
      <rect x="8.5" y="8.5" width="11" height="11" />
      <path d="M15.5 8.5v-4h-11v11h4" />
    </>
  ),
  external: <path d="M14 5h5v5M19 5l-8 8M17 14v5H5V7h5" />,
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" />
      <path d="m4 6 8 7 8-7" />
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5.5" width="16" height="14.5" />
      <path d="M4 10h16M8.5 3.5v4M15.5 3.5v4" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11Z" />
      <circle cx="12" cy="10" r="2.3" />
    </>
  ),
  ruler: <path d="M3.5 15.5 15.5 3.5l5 5-12 12ZM7 12l1.8 1.8M9.5 9.5l2.5 2.5M12 7l1.8 1.8M14.5 4.5 17 7" />,
};

export default function Icon({ name, size = 20, className = "", title }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="square"
      strokeLinejoin="miter"
      className={`sh-icon ${className}`}
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
    >
      {title && <title>{title}</title>}
      {paths[name]}
    </svg>
  );
}
